import addInfoBarMessage from './addInfoBarMessage';
import loadSmimeComposeInfobars from './loadSmimeComposeInfobars';
import loadAttachmentPolicyInfoBars from '../orchestrators/loadAttachmentPolicyInfoBars';
import { ComposeViewState } from 'owa-mail-compose-store';
import addCLPLabelInfoBar from '../utils/addCLPLabelInfoBar';
import addEncryptionInfobarFromIRMData from '../utils/addEncryptionInfobarFromIRMData';
import addMessageClassificationInfoBar from 'owa-mail-message-classification/lib/utils/addMessageClassificationInfoBar';
import updateSensitivityInfoBar from '../utils/updateSensitivityInfoBar';
import { isFeatureEnabled } from 'owa-feature-flags';
import isCLPEnabled from 'owa-mail-clp/lib/utils/isCLPEnabled';
import { action } from 'satcheljs/lib/legacy';

export default action('loadComposeInfoBars')(function loadComposeInfoBars(
    viewState: ComposeViewState
) {
    if (!isFeatureEnabled('cmp-upgradeCompose')) {
        // Add "quoted body will be loaded" infobar if quoted body is not loaded for smart response in full compose
        if (
            viewState.useSmartResponse &&
            !viewState.isInlineCompose &&
            !viewState.itemId &&
            !viewState.quotedBody
        ) {
            addInfoBarMessage(viewState, 'warningNoQuotedBody');
        }
    }
    loadAttachmentPolicyInfoBars(viewState);

    updateSensitivityInfoBar(viewState);

    if (
        isFeatureEnabled('cmp-message-classification') &&
        viewState.classificationViewState &&
        viewState.classificationViewState.messageClassification
    ) {
        addMessageClassificationInfoBar(viewState, viewState.composeId);
    }

    isFeatureEnabled('cmp-smimeAdminSettings') && loadSmimeComposeInfobars(viewState);

    // Scenarios:
    // New Compose, CLP enabled ---> should show default label.
    // Reply/forward, CLP enabled, reference item has RMS and has label ---> should only show label.
    // Reply/forward, CLP enabled, reference item has RMS and does not have label ---> should show RMS template and default label.
    // Reply/forward, CLP enabled, reference item does not have RMS and have label ---> only label should show.
    // Reply/forward, CLP not enabled, reference item has RMS and does have label ---> should only show RMS template.
    // Reply/forward, CLP not enabled, reference item does not have RMS and does/does not have label ---> should not show any infobar.

    if (!isCLPEnabled()) {
        addEncryptionInfobarFromIRMData(viewState);
    }

    addCLPLabelInfoBar(viewState);
});
